import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { components } from '../../../Utils/ReactSelectComponents';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import TablePagination from '@material-ui/core/TablePagination';
import InputAdornment from '@material-ui/core/InputAdornment';
import ApplyIcon from '@material-ui/icons/Update';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import NoDealIcon from '@material-ui/icons/RemoveShoppingCart';
import CheckIcon from '@material-ui/icons/Check';
import OrderIcon from '@material-ui/icons/AssignmentTurnedIn';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import LocationIcon from '@material-ui/icons/Room';
import UsedRentalsCarsListAPI from '../../../../API/UsedRentalsCarsListAPI';
import RUCarDetailInfo from './RUCarDetailInfo';
import RUCarOrderAssociation from './UsedRentalsCarOrdering/RUCarOrderAssociation';
import RUCarsListTableHeader from './RUCarsListTableHeader';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import LinearProgress from '../../../Utils/LinearProgress';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { FormatDate, StringAllOptionals } from '../../../Utils/GenericFunctions';
import { handleServerError, handleSpecialCharacters } from '../../../../Utils/Helper';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_ASCENDING, ORDER_BY_COLOR, UR_GROUP, UR_PHASE } from '../../../../Utils/Constants';

const styles = theme => ({
  paperRoot: {
    width: '100%',
    marginTop: '120px',
    backgroundColor: '#F6F6F6',
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px',
  },
  width100: {
    width: '100%',
    textAlign: 'left'
  },
  gridRoot: {
    flexGrow: 1,
    padding: '0px 24px 4px 32px'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textOptionals: {
    paddingLeft: '6px',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '6px'
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  alignIcons: {
    display: 'flex'
  },
  iconsWidth: {
    width: '120px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  },
  searchField: {
    marginTop: '22px'
  },
  searchIconMargin: {
    marginRight: '4px'
  },
  //DON'T REMOVE (Used in StringAllOptionals)
  textAquaBlue: {
    color: '#00B1AF'
  },
  textGrassGreen: {
    color: '#009A17'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  },
  chip: {
    margin: theme.spacing.unit / 6
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  }
});


export class RUCarsListTable extends Component {
  ruL1Id = this.props.negotiationLot.L1ID;
  searchTimer = null;
  l4ListAPI;

  constructor(props) {
    super(props);
    this.state = {
      reloading: false,
      loading: false,
      success: false,
      optionalsSearchData: [],
      colorSearchData: [],
      optionalsSearch: [],
      optionalsSearchIds: [],
      colorSearch: 0,
      data: [],
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_COLOR,
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      searchBy: '',
      count: 0,
      carDetail: {},
      openDetailDialog: false,
      openOrderDialog: false,
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      openError: false,
      openSuccess: false,
      alertMessage: '',
      openDialogForced: false
    };
    this.l4ListAPI = new UsedRentalsCarsListAPI();
  }

  componentDidMount() {
    this.reloadL4Table();
  };

  componentWillReceiveProps(props) {
    if (props.excelImport === 'Ficheiro submetido com sucesso!')
      this.reloadL4Table();
  };

  reloadL4Table() {
    this.setState({ reloading: true });
    Promise.all([this.l4ListAPI.getOptionalsByRUL1Id(this.ruL1Id), this.l4ListAPI.getColorsByRUL1Id(this.ruL1Id),
    this.l4ListAPI.getL4List(this.ruL1Id, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.searchBy, this.state.colorSearch.value, this.state.optionalsSearchIds)]).then((response) => {
      this.setState({
        optionalsSearchData: response[0].data,
        colorSearchData: response[1].data,
        data: response[2].data.CarList,
        count: response[2].data.NumberFilteredResults,
        page: STARTING_TABLE_PAGE,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  reloadL4BySearch = name => event => {
    this.setState({ reloading: true, [name]: handleSpecialCharacters(event.target.value) });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.l4ListAPI.getL4List(this.ruL1Id, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.searchBy, this.state.colorSearch.value, this.state.optionalsSearchIds).then((response) => {
        this.setState({
          data: response.data.CarList,
          count: response.data.NumberFilteredResults,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
      }).catch((error) => {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }, 1500);
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    this.l4ListAPI.getL4List(this.ruL1Id, page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.searchBy, this.state.colorSearch.value, this.state.optionalsSearchIds).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        page: page,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    this.l4ListAPI.getL4List(this.ruL1Id, this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.searchBy, this.state.colorSearch.value, this.state.optionalsSearchIds).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        rowsPerPage: event.target.value,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    this.l4ListAPI.getL4List(this.ruL1Id, this.state.page, this.state.rowsPerPage, orderBy, order, this.state.searchBy, this.state.colorSearch.value, this.state.optionalsSearchIds).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        order, orderBy,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  handleCloseDetailDialog = () => {
    this.setState({ openDetailDialog: false });
  };

  handleCloseOrderDialog = () => {
    this.setState({ openOrderDialog: false });
  };

  handleCloseDialogForced = () => {
    this.setState({ openDialogForced: false });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      openSuccess: false,
      alertMessage: ''
    });
  };

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleClickFilter = (cor, optionals) => {
    this.setState({ reloading: true });
    var optionalIds = [];
    optionals.forEach(function (obj) {
      optionalIds.push(obj.value);
    });
    this.l4ListAPI.getL4List(this.ruL1Id, this.state.page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.searchBy, cor.value, optionalIds).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        optionalsSearchIds: optionalIds,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleCloseL4Edition = () => {
    this.props.handleCloseL4Edition();
  };

  handleGoBack = () => {
    this.props.handleGoBack();
  };

  handleClickDetail = (carInfo) => {
    this.setState({
      openDetailDialog: true,
      carDetail: carInfo
    });
  }

  handleClickOrder = (carInfo) => {
    this.setState({
      openOrderDialog: true,
      carDetail: carInfo
    });
  }

  handleClickQuitDeal = (carId) => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende DESISTIR DO NEGÓCIO da viatura?',
      confirmationMessage: 'A informação relativamente a: Nº Encomenda, Cliente, Data Registo, Data Prevista Chegada Destino, Data Chegada Destino e Data Efetiva Entrega será limpa. ' +
        'As flags Stock, Reserva e Transporte colocadas a não e a viatura ficará disponível para um novo negócio.',
      confirmationFunction: () => this.handleSubmitQuitDeal(carId, false),
      cancelFunction: this.handleCloseDialog
    });
  }

  handleConfirmQuitDeal = (carId) => {
    this.setState({
      loading: false,
      openDialog: false,
      openDialogForced: true,
      confirmationQuestion: "Tem a certeza que pretende DESISTIR DO NEGÓCIO da viatura?",
      confirmationFunction: () => this.handleSubmitQuitDeal(carId, true),
      cancelFunction: this.handleCloseDialogForced
    });
  };

  handleClickDelete = (carId) => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR a viatura?',
      confirmationMessage: 'A informação relativamente à viatura será eliminada e esta apenas poderá ser visualizada na base de dados.',
      confirmationFunction: () => this.handleSubmitDelete(carId, false),
      cancelFunction: this.handleCloseDialog
    });
  };

  handleConfirmDeleteCar = (carId) => {
    this.setState({
      loading: false,
      openDialog: false,
      openDialogForced: true,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR a viatura?',
      confirmationFunction: () => this.handleSubmitDelete(carId, true),
      cancelFunction: this.handleCloseDialogForced
    });
  };

  handleSubmitDelete = (carId, forceSave) => {
    this.setState({ loading: true })
    this.l4ListAPI.deleteCar(carId, forceSave).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
        this.reloadL4Table();
      }, 500);
      this.props.reloadRUManagementLotsTableList();
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf('cancelem as mesmas') > -1) {
        this.setState({
          confirmationMessage: 'As viaturas da marca ' + this.props.negotiationLot.Brand +
            ' e modelo ' + this.props.negotiationLot.Model +
            ' possuem reservas associadas à totalidade de viaturas disponíveis, a eliminação da viatura terá impacto sobre as reservas. '
            + handleServerError(error)
        })
        this.handleConfirmDeleteCar(carId);
      }
      else {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
      }
    });
  };

  handleSubmitQuitDeal = (carId, forceSave) => {
    this.setState({ loading: true })
    this.l4ListAPI.quitDeal(carId, forceSave).then((response) => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
        if (response.data) {
          this.handleCloseL4Edition();
          this.handleGoBack();
        }
        else {
          this.reloadL4Table();
        }
      }, 500);
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf("lote encontra-se encerrado") > -1) {
        this.setState({
          confirmationMessage: "O lote da marca " + this.props.negotiationLot.Brand + " e modelo " + this.props.negotiationLot.Model +
            " encontra-se encerrado. A desistência do negócio fará com que o mesmo retroceda para Renting Usados."
        })
        this.handleConfirmQuitDeal(carId);
      }
      else {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
      }
    });
  };

  renderSearchSelect() {
    const { classes } = this.props;
    return (
      <div>
        <Grid container spacing={8} className={classes.gridRoot}>
          <Grid item xs={12} sm={4}>
            <Grid container justify='center'>
              <div className={classes.width100}>
                <InputLabel htmlFor='colorSearch'>
                  COR
              </InputLabel>
                <ReactSelect
                  classes={classes}
                  options={this.state.colorSearchData}
                  components={components}
                  value={this.state.colorSearch}
                  onChange={this.handleChangeSelect('colorSearch')}
                  placeholder=''
                />
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container justify='center'>
              <Grid item xs={12} sm={11}>
                <div className={classes.width100}>
                  <InputLabel htmlFor='optionalSearch'>
                    OPCIONAIS
                  </InputLabel>
                  <ReactSelect
                    classes={classes}
                    options={this.state.optionalsSearchData}
                    components={components}
                    value={this.state.optionalsSearch}
                    onChange={this.handleChangeSelect('optionalsSearch')}
                    placeholder=''
                    isMulti
                    closeMenuOnSelect={false}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Grid container justify='flex-end'>
                  <Grid item>
                    <Tooltip title='Aplicar Filtro' placement='bottom' >
                      <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickFilter(this.state.colorSearch, this.state.optionalsSearch) }} >
                        <ApplyIcon />
                      </Button>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              id='search'
              label=''
              placeholder='Pesquisar'
              type='search'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start' className={classes.searchIconMargin}>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              className={classes.searchField}
              value={this.state.searchBy}
              onChange={this.reloadL4BySearch('searchBy')}
            />
          </Grid>
        </Grid>
      </div >
    );
  }

  renderTableRecords(aCarList) {
    const { classes } = this.props;

    const ruL4List = aCarList.map(ruCarItem => {
      return (
        <TableRow key={ruCarItem.L4ID} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {StringAllOptionals(ruCarItem.ListNegotiatedOptionalsDescription, ruCarItem.ListAnnouncedOptionalsDescription, this.props)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.ColourDescription}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.SalesChannelsDescription}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.LicensePlate}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(ruCarItem.LicensePlateDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(ruCarItem.StockEntryDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.Ageing > '700000' ? null : ruCarItem.Ageing}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.A1Created === true ? <CheckIcon /> : null}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.Stock === true ? <CheckIcon /> : null}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.Booking === true ? <CheckIcon /> : null}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.Transportation === true ? <CheckIcon /> : null}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.ClientName}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.OrderNumber}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {ruCarItem.OrderStatus}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.iconsWidth)} padding='none'>
            <div className={classes.alignIcons}>
              <Tooltip title={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0 ? 'Detalhe Viatura' : 'Editar Viatura'} placement='bottom' >
                <IconButton aria-label='Edit' onClick={() => { this.handleClickDetail(ruCarItem) }} className={classes.buttonSizeTbl} >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              {ruCarItem.Observations !== null && ruCarItem.Observations !== '' ?
                <Tooltip title={ruCarItem.Observations} placement='bottom'>
                  <IconButton aria-label={ruCarItem.Observations} className={classes.buttonSizeTbl} >
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
                : null}
              {ruCarItem.OriginalLocation !== null && ruCarItem.OriginalLocation !== '' ?
                <Tooltip title={ruCarItem.OriginalLocation} placement='bottom'>
                  <IconButton aria-label={ruCarItem.OriginalLocation} className={classes.buttonSizeTbl} >
                    <LocationIcon />
                  </IconButton>
                </Tooltip>
                : null}
              <Tooltip title='Associar Encomenda' placement='bottom' >
                <IconButton disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} aria-label='Order' onClick={() => { this.handleClickOrder(ruCarItem) }} className={classes.buttonSizeTbl} >
                  <OrderIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title='Desistir do Negócio' placement='bottom' >
                <IconButton disabled={this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} aria-label='noDeal' onClick={() => { this.handleClickQuitDeal(ruCarItem.L4ID) }} className={classes.buttonSizeTbl} >
                  <NoDealIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title='Eliminar Viatura' placement='bottom' >
                <IconButton disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0} aria-label='Delete' onClick={() => { this.handleClickDelete(ruCarItem.L4ID) }} className={classes.buttonSizeTbl} >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </div>
          </TableCell>
        </TableRow>
      );
    })
    return ruL4List;
  }


  render() {
    const { classes } = this.props;
    const { data, rowsPerPage, page, count, reloading, order, orderBy, loading, success } = this.state;

    return (
      <Paper className={classes.paperRoot}>

        {this.renderSearchSelect()}

        <span className={classes.textOptionals}>*
          <span className={classes.textAquaBlue}>Opcionais Negociados e Anunciados</span>
          <span> || </span>
          <span className={classes.textGrassGreen}>Opcionais Negociados</span>
          <span> || </span>
          <span>Opcionais Anunciados</span>
        </span>

        <span className={classes.tableWrapper}>
          <Table>
            <TableHead className={classes.tblHead} >
              <RUCarsListTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
            </TableHead>
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {reloading && <LinearProgress />}
          <TablePagination
            component='div'
            count={count}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            labelRowsPerPage={'Resultados por página:'}
            page={page}
            backIconButtonProps={{ className: classes.pageButton }}
            nextIconButtonProps={{ className: classes.pageButton }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
            classes={{ toolbar: classes.tblFooter }}
          />
        </span>

        <Dialog
          fullScreen
          open={this.state.openDetailDialog}
          onClose={this.handleCloseDetailDialog.bind(this)}
        >
          <RUCarDetailInfo
            estadoLotId={this.props.estadoLotId}
            handleClose={this.handleCloseDetailDialog.bind(this)}
            carDetail={this.state.carDetail}
            carModelData={this.props.negotiationLot}
            reloadL4Table={this.reloadL4Table.bind(this)}
          />
        </Dialog>

        <Dialog
          fullScreen
          open={this.state.openOrderDialog}
          onClose={this.handleCloseOrderDialog.bind(this)}
        >
          <RUCarOrderAssociation
            handleClose={this.handleCloseOrderDialog.bind(this)}
            carDetail={this.state.carDetail}
            carModelData={this.props.negotiationLot}
            reloadL4Table={this.reloadL4Table.bind(this)}
          />
        </Dialog>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={loading}
            success={success}
          />
        </Dialog>

        <Dialog
          open={this.state.openDialogForced}
          onClose={this.handleCloseDialogForced}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialogForced}
            handleClose={this.handleCloseDialogForced.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={loading}
            success={success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} openSuccess={this.state.openSuccess} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUCarsListTable));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsManagement/UsedRentalsCarsList/RUCarsListTable.js